// extracted by mini-css-extract-plugin
export default {"availabilityText":"ProductCardAvailabilityText_availabilityText__7IqUD"};